export default {
  // Add app specific config settings here (unlikely to need to.  See ../clubSettings/index.js)
}
